System.import('single-spa')
  .then((singleSpa: any) => {
    const { registerApplication, start, addErrorHandler } = singleSpa;

    addErrorHandler((err: Error & { appOrParcelName?: string }) => {
      fetch('/error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'wallet-stored-payments-wrapper-load-failure',
          appOrParcelName: err.appOrParcelName,
          message: err.message,
        }),
      }).catch((fetchErr) => {
        console.error('Failed to report error:', fetchErr, 'Original error:', err);
      });
    });

    registerApplication({
      name: '@wallet/wallet-ui',
      app: () => System.import('@wallet/wallet-ui'),
      activeWhen: '/wallet',
      customProps: {},
    });

    registerApplication({
      name: '@app/payment-sheet',
      app: () => System.import('@app/payment-sheet'),
      activeWhen: '/payment-sheet',
      customProps: {},
    });

    start();
  })
  .catch((err: unknown) => {
    const message = err instanceof Error ? err.message : String(err);
    fetch('/error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        type: 'wallet-stored-payments-wrapper-shell-failure',
        message,
      }),
    }).catch((fetchErr) => {
      console.error('Failed to report shell error:', fetchErr);
    });
  });
